/**
 * Vector2D
 */
export class Vector2D {
    /**
     *
     */
    constructor(x, y) {
        this.x = x != undefined ? x : 0;
        this.y = y != undefined ? y : 0;
    }

    /**
     * @return
     */
    clone() {
        return new Vector2D(this.x, this.y);
    }

    /**
     * @return
     */
    copy() {
        return this.clone();
    }

    /**
     * @param v
     * @return
     */
    set(v, w = undefined) {
        if (w !== undefined) {
            this.x = v;
            this.y = w;
        } else {
            this.x = v.x;
            this.y = v.y;
        }
        
        return this;
    }

    /**
     * @param v
     * @return
     */
    pos(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }

    /**
     * @return
     */
    zero() {
        this.x = 0;
        this.y = 0;
        return this;
    }

    /**
     * @return
     */
    isZero() {
        return this.x == 0 && this.y == 0;
    }

    /**
     * @return
     */
    random(length) {
        return this.set(2 * length * (Math.random() - 0.5), 2 * length * (Math.random() - 0.5));
    }

    /**
     * @param v
     * @return
     */
    add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }

    /**
     * @param v
     * @return
     */
    sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }

    /**
     * @param s
     * @return
     */
    scale(sx, sy) {
        this.x *= sx;
        this.y *= sy != undefined ? sy : sx;
        return this;
    }

    /**
     * @param tx
     * @param ty
     * @return
     */
    translate(tx, ty) {
        this.x += tx;
        this.y += ty;
        return this;
    }

    /**
     * @param v
     * @return
     */
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }

    /**
     * @return
     */
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }

    /**
     * @param v
     * @return
     */
    length() {
        return Math.sqrt(this.lengthSq());
    }

    /**
     * @return
     */
    normalize() {
        var s = this.length();
        if (s > 0) {
            s = 1 / s;
        }

        this.x *= s;
        this.y *= s;
        return this;
    }

    /**
     * @return
     */
    invert() {
        this.x *= -1;
        this.y *= -1;
        return this;
    }
}

export const ZERO = new Vector2D(0, 0);
const temp1 = new Vector2D(0, 0);
const temp2 = new Vector2D(0, 0);

/**
 * @param v1
 * @param v2
 * @return
 */
export function dot(v1, v2) {
    return v1.dot(v2);
}

/**
 * @param a
 * @param b
 * @param p
 * @return
 */
export function projectPointOnLine(a, b, p, out) {
    out.set(a);
    temp1.set(b).sub(a);
    var f = temp1.lengthSq();
    if (f != 0) {
        temp2.set(p).sub(a);
        out.add(temp1.scale(dot(temp2, temp1) / f));
    }
}

/**
 * @param a
 * @param b
 * @param p
 * @param out
 * @return
 */
export function mirrorPointOnLine(a, b, p, out) {
    projectPointOnLine(a, b, p, out);
    out.sub(p).scale(2).add(p);
}
